/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {forwardRef} from 'react';
import {defineMessages} from 'react-intl';
import {Link} from 'react-router-dom';
import {Button} from 'react-bootstrap';
import {useFormatMessage} from 'app/hooks';
import NextIcon from 'icons/NextIcon';

const messages = defineMessages({
  title: {
    id: 'label.button.next',
    description: 'Next button label',
    defaultMessage: 'Next',
  },
});

const NextIconButton = (
  {variant = 'light', title = messages.title, href, ...props},
  ref
) => {
  const titleText = useFormatMessage(title, title.values);
  if (href) {
    return (
      <Button
        ref={ref}
        as={Link}
        to={href}
        variant={variant}
        title={titleText}
        {...props}
      >
        <NextIcon />
      </Button>
    );
  }
  return (
    <Button ref={ref} variant={variant} title={titleText} {...props}>
      <NextIcon />
    </Button>
  );
};
NextIconButton.displayName = 'NextIconButton';

export default forwardRef(NextIconButton);
